import * as React from 'react';

const SvgLinkedin = (props) => (
  <svg
    width={16}
    height={16}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#Linkedin_svg__a)'>
      <path
        d='M.308 1.434C.308.835.818.338 1.449.338H14.55c.631 0 1.142.491 1.142 1.096v13.132c0 .599-.51 1.095-1.142 1.095H1.45c-.632 0-1.142-.49-1.142-1.095V1.434Z'
        fill='#fff'
      />
      <path
        d='M4.983 13.16V6.263H2.682v6.895h2.301ZM3.835 5.317c.8 0 1.298-.526 1.298-1.19-.012-.677-.498-1.192-1.28-1.192-.787 0-1.304.515-1.304 1.197 0 .659.5 1.191 1.274 1.191h.012v-.006Zm2.422 7.841H8.56V9.317c0-.21.018-.42.078-.563.162-.407.54-.838 1.178-.838.835 0 1.166.635 1.166 1.556v3.693h2.308v-3.95c0-2.119-1.136-3.113-2.645-3.113A2.303 2.303 0 0 0 8.553 7.27h.012V6.264H6.257c.03.646 0 6.895 0 6.895Z'
        fill='#333'
      />
    </g>
    <defs>
      <clipPath id='Linkedin_svg__a'>
        <path
          fill='#fff'
          transform='translate(.308 .308)'
          d='M0 0h15.385v15.385H0z'
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLinkedin;
